export const convertSweepToDecimal = (sweep: number) => {
    return Math.round(sweep * 100) / 10000;
};
export const convertSweepToPercentage = (sweep: number) => {
    return Math.round(sweep * 10000) / 100;
};
